import React, { useContext, useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { Loader } from './Loader';
import { Event } from './Event';
import moment from 'moment';
import { BigCalendarConverter, IEvent } from './models';
import { collection, limit, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { FirebaseContext } from './context';
import { Button } from './Button';

const localizer = momentLocalizer(moment);

export const PageCalendar = () => {
    const { db } = useContext(FirebaseContext);
    const [ loading, setLoading ] = useState(true);
    const [ events, setEvents ] = useState<IEvent[]>([]);
    const [ eventsNum, setEventsNum ] = useState(5);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, '/v2-events'), orderBy('end', 'desc'), limit(eventsNum)), (snapshot) => {
                setLoading(false) 
                setEvents(snapshot.docs.map((doc) => {
                    return {...doc.data(), id: doc.id} as IEvent;
                }))
            });
        }
    }, [db, eventsNum]);
    return <div>
        <Loader loading={loading} />
        <div className='padding-x'>
            <div className='text-center py-10'>
                <p className="text-4xl mb-5">Календарь</p>
                <p className="text-lg">Мероприятия</p>
            </div>
            <div className='mb-10 space-y-5'>
                { events.map((e) => <Event id={e.id} image={e.image} title={e.title} start={moment(e.start.toMillis()).format('hh:mm DD.MM.YY')} end={moment(e.end.toMillis()).format('hh:mm DD.MM.YY')} description={e.description} key={e.id} outdated={Date.now() > e.end.toMillis()}/>)}
                { events.length <= 0 ? <p>Нет запланированных мероприятий</p> : null}
            </div>
            <div className="flex justify-center p-10">
                <Button label='Загрузить ещё' onClick={() => setEventsNum(eventsNum + 5)}/>
            </div>
            <div className="mb-10">
                <Calendar
                    localizer={localizer}
                    events={events.map((e) => BigCalendarConverter.toBigCalendarEvent(e))}
                    startAccessor="start"
                    endAccessor="end"
                    messages={{
                        next: "Вперёд",
                        previous: "Назад",
                        today: "Сегодня",
                        month: "Месяц",
                        week: "Неделя",
                        day: "День",
                    }}
                    // onSelectEvent={event => alert(event.title)}
                    views={['month', 'day', 'week']}
                    defaultView={'week'}
                />
            </div>
        </div>
    </div>
}